import * as React from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from '../../common';
import { CodeCodetablePickerProps } from './types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeActionType } from 'app/area/codetable/item/types';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';

export interface CodeParentProps extends Omit<CodeCodetablePickerProps, 'onChange'> {
  onChange: (parent: ComplexValue<number>, codetableId: number, shouldLoadParentCategory?: boolean) => void;
}

export const CodeParent = (props: CodeParentProps) => {

  const { breadcrumbs, metadata, codeItem, codeItem: { category: { value: categoryId } = {} } = {},
    options, loadOptions, translation, validation: { parent: parentValidation } = {}, readOnly,
    actionType } = props;

  if (!metadata || !!metadata && !!metadata.features && !metadata.features.hierarchy) {
    return null;
  }

  const codetableId = !!metadata && !!metadata.codetable && isDefinedIncludingZero(metadata.codetable.id)
    ? metadata.codetable.id
    : undefined;

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, codetableId, { ...loadOptionsParams, categoryId });
  };

  const isCodeDuplicating = actionType === CodeActionType.Duplicate;

  const isCodeEditing = codeItem && isDefinedIncludingZero(codeItem.id);

  const shouldLoadParentCategory = !(!isCodeDuplicating && (isCodeEditing || readOnly));

  const onChange = (parent: ComplexValue<number>) => props.onChange(parent, codetableId, shouldLoadParentCategory);

  const codeOptions = (!!options.parent && options.parent.codes || []) as ComplexValue<number>[];
  const finalValidation = { ...parentValidation, ...getDisabledValidation(codeItem.parent?.disabled, translation.selected_value_disabled) };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs, categoryId);

  return <CodeSinglePicker
    id="parent"
    label={translation ? translation.parent_code : undefined}
    valueItem={codeItem && codeItem.parent}
    searchRequired={codetableId && metadata.codetable.searchRequired}
    readOnly={readOnly}
    extraFooterButton={extraFooterButton}

    options={codeOptions}
    fetchingOptions={options.parent && options.parent.fetching}

    translation={translation}
    validation={finalValidation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
  />;
};
